module.exports = __webpack_public_path__ + "img/aat_logo.d768c9bf.jpg";